<template>
	<v-form>
		<v-container>
			<v-layout row wrap>
				<v-flex xs12>
					<img
						src="../../assets/bitacorapp-logo.png"
						width="320"
						alt=""
					/>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						label="Usuario"
						v-model="credentials.username"
						style="text-transform: lowercase"
					/>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						label="Contraseña"
						v-model="credentials.password"
						:type="showPassword ? 'input' : 'password'"
						:append-icon="
							showPassword ? 'visibility_off' : 'visibility'
						"
						@click:append="showPassword = !showPassword"
					/>
				</v-flex>
				<v-flex xs12>
					<v-btn block color="primary" @click.prevent="login"
						>Ingresar</v-btn
					>
				</v-flex>
			</v-layout>
			<v-layout justify-space-between="true">
				<v-btn
					small
					outline
					color="primary"
					@click="$router.push({ name: 'register' })"
					>Registrarme</v-btn
				>

				<v-btn
					small
					outline
					color="primary"
					@click="$router.push({ name: 'RecoverPassword' })"
					>Recuperar Contraseña</v-btn
				>
			</v-layout>
			<v-snackbar
				v-model="loginError"
				:bottom="true"
				:timeout="3000"
				text="Error al autenticarse"
			>
				{{ errorMessage }}
				<v-btn color="pink" flat @click="loginError = false">
					Cerrar
				</v-btn>
			</v-snackbar>
			<!-- Mecanismo de activación de notificaciones -->
			<v-dialog v-model="showNotificationsWindow">
				<v-card>
					<v-card-title class="headline orange white--text">
						Activación de notificaciones
					</v-card-title>
					<v-card-text>
						¿Desea recibir una notificación cuando reciba a un
						visitante o correpondencia nueva?
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat color="green" @click="acceptNotifications"
							>SI</v-btn
						>
						<v-btn flat color="red" @click="denyNotifications"
							>NO</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!-- FIN Mecanismo de activación de notificaciones -->
		</v-container>
	</v-form>
</template>
<script>
import authRepository from '@/repositories/auth.repository'
import * as commitTypes from '../../store/commitTypes'
import * as actionTypes from '../../store/actionTypes'
import { mapActions } from 'vuex'
import Bowser from 'bowser'
export default {
	data() {
		return {
			credentials: {
				username: '',
				password: '',
			},
			showPassword: false,
			loginError: false,
			errorMessage: 'Error desconocido',
			showNotificationsWindow: false,
			debug: '',
		}
	},
	watch: {
		'credentials.username'(val) {
			this.credentials.username = val.toLowerCase()
		},
	},
	computed: {
		browserSpects() {
			return Bowser.parse(window.navigator.userAgent)
		},
	},
	methods: {
		...mapActions({
			saveBrowserSpects: actionTypes.SAVE_BROWSER_SPECTS,
			saveNotificationsSupport: actionTypes.SAVE_NOTIFICATIONS_SUPPORT,
			updateSubscription: actionTypes.UPDATE_SUBSCRIPTION,
			saveNotificationsAllowed: actionTypes.SAVE_NOTIFICATIONS_ALLOWED,
		}),
		login() {
			const ar = { ...authRepository }
			ar.login(
				this.credentials.username.toLowerCase(),
				this.credentials.password
			)
				.then(({ data }) => {
					if (!data.status) {
						this.errorMessage = data.msg
						this.loginError = true
						return
					}
					// this.$store.commit(commitTypes.SET_USER, resp.data);
					this.$store.commit(commitTypes.SET_USER, data.user)
					// this.$store.dispatch(actionTypes.VERIFY_SUBSCRIPTION);
					try {
						// if (browsertDetect() === 'safari')
						// 	this.finishNotificationSubscription()
						this.startNotificationSubscription()
					} catch (error) {
						console.log(error)
					}
				})
				.catch(error => {
					if (error) {
						this.loginError = true
					}
				})
		},
		startNotificationSubscription() {
			if (!window.hasOwnProperty('Notification')) {
				this.saveNotificationsSupport('NO')
				// this.errorMessage = 'Su navegador no soporta notificaciones'
				// this.loginError = true
				return this.finishNotificationSubscription()
			}
			this.saveNotificationsSupport('SI')
			if (Notification.permission === 'granted') {
				this.updateSubscription()
				this.finishNotificationSubscription()
			} else if (
				Notification.permission !== 'denied' ||
				Notification.permission === 'default'
			) {
				this.showNotificationsWindow = true
			} else {
				this.errorMessage =
					'Si desea recibir notificaciones debe habilitarlas manualmente'
				this.loginError = true
				this.finishNotificationSubscription()
			}
		},
		acceptNotifications() {
			Notification.requestPermission(permission => {
				if (permission === 'granted') {
					this.saveNotificationsAllowed('SI')
					this.updateSubscription()
						.then(resp => {
							new Notification('Notificaciones activadas')
							this.finishNotificationSubscription()
						})
						.catch(error => {
							this.errorMessage =
								'Ocurrió un error al subscribirse al servicio de notificaciones'
							this.loginError = true
							this.finishNotificationSubscription()
						})
				} else {
					this.errorMessage =
						'Notificaciones bloqueadas por el usuario'
					this.loginError = true
					this.saveNotificationsAllowed('NO')
					this.finishNotificationSubscription()
				}
				this.showNotificationsWindow = false
			})
		},
		denyNotifications() {
			this.showNotificationsWindow = false
			this.saveNotificationsAllowed('NO')
			this.errorMessage = 'No recibirá notificaciones desde bitacorapp'
			this.loginError = true
			this.finishNotificationSubscription()
		},
		finishNotificationSubscription() {
			this.$router.push({ name: 'home' })
		},
	},
	created() {},
}

const browsertDetect = () => {
	if (
		(navigator.userAgent.indexOf('Opera') ||
			navigator.userAgent.indexOf('OPR')) != -1
	) {
		return 'opera'
	} else if (navigator.userAgent.indexOf('Chrome') != -1) {
		return 'chrome'
	} else if (navigator.userAgent.indexOf('Safari') != -1) {
		return 'safari'
	} else if (navigator.userAgent.indexOf('Firefox') != -1) {
		return 'firefox'
	} else if (
		navigator.userAgent.indexOf('MSIE') != -1 ||
		!!document.documentMode == true
	) {
		//IF IE > 10
		return 'ie'
	} else {
		return 'unknown'
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue